import { ActivePageAction, IActivePage } from "../../interfaces/ActivePage"
import { UPDATE_ACTIVE_PAGE } from "./types"

const initialState: IActivePage = {
	title: "HOME"
}

const activePageReducer = (
	state: IActivePage = initialState,
	action: ActivePageAction
): IActivePage => {
	switch (action.type) {
		case UPDATE_ACTIVE_PAGE:
			return {
				...state,
				title: action.title,
			}
		default:
			return {
				...state,
				title: initialState.title,
			}
	}
}

export default activePageReducer;